export const MATCH = 'match';
export const CRAZY_ARROWS = 'crazy-arrows';
export const TRIPLE_ARROWS = 'triple-arrows';
export const PONT_OR_MOVE = 'point-or-move';
export const POINTING = 'pointing';
export const LEVEL1 = 0;
export const LEVEL2 = 1;
export const GAME_TIME = 60;
export const NEW_DATA_EVENT = 'NEW_DATA_EVENT';
export const TOTAL_LEVELS = 2;
export const PAUSE_TIMER_EVENT = "PAUSE_TIMER_EVENT"
export const RESUME_TIMER_EVENT = "RESUME_TIMER_EVENT"
